import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';

import {
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  ReactiveFormsModule,
  FormBuilder,
} from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  imports: [CommonModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class RadioComponent implements OnInit, ControlValueAccessor {
  @Input() form!: FormGroup;
  @Input() input_name = 'input_radio';
  @Input() description: string = '';
  @Input() active = false;
  @Input() label: any;
  @Input() disabled = false;
  @Input() value = 'male';
  @Input() checked: boolean = false;
  @Output() selected = new EventEmitter<string>();

  ngOnInit(): void {
    if (!this.form) {
      this.form = new FormGroup({
        [this.input_name]: new FormControl({
          value: this.active ? this.value : '',
          disabled: this.disabled,
        }),
      });
    }
  }

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onRadioChange(value: any): void {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
    this.selected.emit(this.value);
  }
}
